export default "__VITE_ASSET__BPj06AbI__"